export default {
	showAddFeedback: false,
	feedbackList:{
        data: null,
    },
}
